class LoyaltyPointsTotal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    const shopCurrency = window.theme.shopCurrency
    const localCurrency = window.theme.localCurrency

    this.getCartTotal = this.getCartTotal.bind(this)

    if (localCurrency === shopCurrency) return

    this.getCartTotal(shopCurrency)
  }

  async getCartTotal () {
    this.setAttribute('aria-busy', true)

    const shopCurrency = window.theme.shopCurrency
    const localCurrency = window.theme.localCurrency

    const cart = await window.BAO.Utils.fetchJSON(
      `/cart.js?currency=${shopCurrency}`,
    )

    const cartTotal = String(cart.total_price)

    const shopCartTotal = (cartTotal / 100) * window.theme.pointsMultiplier

    this.textContent = shopCartTotal

    // Need to set the currency back to the user's local currency
    await window.BAO.Utils.fetchJSON(`/cart.js?currency=${localCurrency}`)

    this.setAttribute('aria-busy', false)
  }
}

if (!customElements.get('loyalty-points-total')) {
  customElements.define('loyalty-points-total', LoyaltyPointsTotal)
}
